/**
 * Labstep
 *
 * @module components/FilterPost/Report/MetadataHasValue/Active/Post
 * @desc Active node component for metadata has value filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import {
  getPostFilterMetadatasHasValue,
  getPostFilterMetadatasHasValueWithName,
} from 'labstep-web/services/postFilter/filters/metadatas';
import type React from 'react';
import type { IFilterPostReportMetadataHasValueActivePostProps } from './types';

const PATHS = [
  'metadatas',
  'resourceItem.metadatas',
  'resourceItem.resource.metadatas',
];

const FILTERS = PATHS.flatMap((path) => [
  getPostFilterMetadatasHasValue(path),
]);

const FILTERSWITHNAME = PATHS.flatMap((path) => [
  getPostFilterMetadatasHasValueWithName(path),
]);

export const FilterPostReportMetadataHasValueActivePost: React.FC<
  IFilterPostReportMetadataHasValueActivePostProps
> = ({ node, onRemoveClick }) => {
  const filter = FILTERS.find((filter) =>
    filter.isNodeActive(node, undefined, false, true),
  );
  const filterWithName = FILTERSWITHNAME.find((filter) =>
    filter.isNodeActive(node, undefined, true, true),
  );

  if (!filter && !filterWithName) {
    return null;
  }

  const filterActive = filterWithName ? filterWithName : filter;

  const attributes = filterActive!.getAttributeValues(node);
  const protocolValueName = (attributes as any).name?.value;

  return (
    <RemoveLabel
      name={
        protocolValueName
          ? `${protocolValueName}: ${attributes.label.value} has any value`
          : `${attributes.label.value} has any value`
      }
      icon={
        filterActive!.getPath()?.includes('resource')
          ? ICONS.metadata.secondary
          : ICONS.metadata.primary
      }
      onRemoveClick={onRemoveClick}
    />
  );
};
